import { Animator } from "./modules/animator.min.67833fd4.js";
import { Company } from "./modules/companyPage.min.10034db1.js";
import { ComparatorManager } from "./modules/comparatorManager.min.0bcc5940.js";
import { ComparatorMemory } from "./modules/comparatorMemory.min.970dad6c.js";
import { EventsManager } from "./modules/eventsManager.min.1b7570be.js";
import { FormManager } from "./modules/formManager.min.49fe5c1e.js";
import { Loading } from "./modules/loading.min.f22a3490.js";
import { LoginForm } from "./modules/loginForm.min.838faa99.js";
import { LoginRequestForm } from "./modules/loginRequestForm.min.eb2d6293.js";
import { MenuManager } from "./modules/menuManager.min.ae753b6f.js";
import { Mep } from "./modules/mep.min.a3b73851.js";
import { NewPasswordForm } from "./modules/newPasswordForm.min.5de784bd.js";
import { PasswordResetForm } from "./modules/passwordResetForm.min.493aedcc.js";
import { PjaxNavigation } from "./modules/pjaxNavigation.min.7b481db1.js";
import { ProfileForm } from "./modules/profileForm.min.f6b66868.js";
import { ScrollManager } from "./modules/scrollManager.min.40b6a8e1.js";
import { SlidersManager } from "./modules/slidersManager.min.aa5bfb4c.js";
import { TabSystem } from "./modules/tabsystemManager.min.4ff852ac.js";
import { Workers } from "./modules/workers.min.8b2c0d2d.js";

// Init workers first
window.workers = new Workers();

window.animator = new Animator();
window.company = new Company();
window.comparator = new ComparatorManager();
window.comparator_memory = new ComparatorMemory();
window.evnManager = new EventsManager();
window.forms = new FormManager();
window.loading = new Loading();
window.loginForm = new LoginForm();
window.loginRequestForm = new LoginRequestForm();
window.menu = new MenuManager();
window.mep = new Mep();
window.passwordResetForm = new PasswordResetForm();
window.pjaxnav = new PjaxNavigation();
window.newPasswordForm = new NewPasswordForm();
window.profileForm = new ProfileForm();
window.scrollManager = new ScrollManager();
window.sliders = new SlidersManager();
window.tabsystem = new TabSystem();

function onNavigationDone() {
  window.loginForm = new LoginForm();
  window.loginRequestForm = new LoginRequestForm();
  window.passwordResetForm = new PasswordResetForm();
  window.profileForm = new ProfileForm();

  window.loginForm.init();
  window.loginRequestForm.init();
  window.passwordResetForm.init();
  window.profileForm.init();
}

function domIsReady() {
  window.app = {
    init: function () {
      window.forms.init();
      window.animator.init();
      window.comparator.init();
      window.comparator_memory.init();
      window.evnManager.init();
      window.loginForm.init();
      window.loginRequestForm.init();
      window.menu.init();
      window.mep.init();
      window.passwordResetForm.init();
      window.profileForm.init();
      window.pjaxnav.init(onNavigationDone);
      window.newPasswordForm.init();
      window.scrollManager.init();
      window.sliders.init();
      window.company.init();
      window.tabsystem.init();
    },
  };

  window.loading.init();
}

// Initialize page
$(function () {
  domIsReady();
});

function gestisciBrMobile() {
  if (window.innerWidth <= 990) {
    document.querySelectorAll('p br, h1 br, h2 br, h3 br').forEach(br => {
      // Sostituisce il BR con un vero nodo di testo contenente uno spazio
      const spazio = document.createTextNode(' ');
      br.parentNode.replaceChild(spazio, br);
    });
  }
}

// Esegui al caricamento e al ridimensionamento
window.addEventListener('DOMContentLoaded', gestisciBrMobile);

